@import 'styles/variables';

.wrapper {
  left: var(--border-format-bar-left);
  opacity: 0;
  position: absolute;
  top: calc(var(--border-format-bar-top) - 16px);
  transform: translate(-50%, -100%);
  z-index: 4;
}

:export {
  rightRailWidth: $right-rail-selector-width;
}
